import { useEffect, useState } from "react";
import { Header, Table } from "react-frontier";
import type { User } from "Classes";
import { getUsers } from "@/Api";

var ListUsers=()=>{
   var[error,setError]=useState<string>(null);
   var[users,setUsers]=useState<User[]>(null);

   var get=()=>{
      getUsers().then(res=>{
         if(res.error) return setError(res.message);
         
         setUsers(res.data);
      }).catch(()=>{
         setError('Ocurrio un error al obtener la lista de usuarios.');
      });
   };

   useEffect(()=>{
      get();
   },[]);

   if(error) return <Header text={error} />;

   return <div style={{padding:'60px', display:'flex', flexDirection:'column', alignItems:'center', gap:'20px'}}>
      <Header text="Usuarios" subtext="Lista de usuarios registrados en el sistema." />
      <Table 
         fitted
         striped
         title='Usuarios'
         style={{width: '800px'}}
         collapsingIndexes={[0,3]}
         headers={['ID','Nombre','Correo','Estatus']}
      >
         {!users?(
            <Table.Row>
               <Table.Cell className="empty" colSpan={4}><Header loading /></Table.Cell>
            </Table.Row>
         ):users.length>0?users.map(u=>(
            <Table.Row
               key={u.user_id}
               data={[
                  u.user_id,
                  `${u.first_name} ${u.last_name}`,
                  u.email,
                  <span style={{
                     color: 'white',
                     fontSize: '12px',
                     padding: '4px 5px',
                     lineHeight: '12px',
                     borderRadius: '100px',
                     backgroundColor: u.active ? '#21ba45' : '#ffa600ff'
                  }}>
                     {u.active?'Activo':'Inactivo'}
                  </span>
               ]}
            />
         )):(
            <Table.Row>
               <Table.Cell className='empty' colSpan={4}>No se encontraron usuarios</Table.Cell>
            </Table.Row>
         )}
      </Table>
   </div>;
};

export default ListUsers;
